<template>
  <div class="wrong-edition">
    <div class="top"><img :src="innerIcon" alt=""></div>
    <div class="main">
      <img :src="error" alt="">
      <p>检测到您当前使用的浏览器版本过低，网页君出不来~</p>
      <p>推荐您使用「 <el-link href="http://chrome.illzjp.cn/browser.html" type="primary">谷歌</el-link>、<el-link href="https://www.firefox.com.cn" type="primary">火狐</el-link>」或其他更高版本的浏览器访问我们哦</p>
    </div>
  </div>
</template>

<script>
import innerIcon from "@/assets/img/inner-icon.png";
import error from "@/assets/img/error.png";
export default {
  data(){
    
    return {
      dialogVisible: false,
      innerIcon,
      error
    }
  },
  methods: {

  }
};
</script>

<style lang="scss" scope>
.wrong-edition {
  padding: 30px;
  display: flex;
  flex-direction: column;
  font-size: 20px;
  height: 100vh;
  .top {
  }
  .main {
    text-align: center;
    flex: 1;
    display: flex;
    min-width: 600px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 30px;
    a{
      font-size: 18px;
    }

  }
}
</style>